
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import ordersalesLogo from "@/assets/ordersales-logo.png";

const Footer = () => {
  return (
    <footer className="bg-white text-black border-t-4 border-black">
      <div className="container-custom">
        <div className="py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
            <div className="md:col-span-5">
              <div className="mb-12">
                <img src={ordersalesLogo} alt="OrderSales.AI" className="h-10" />
              </div>
              <p className="text-black mb-8 max-w-md font-interview-sans text-lg leading-relaxed">
                Muutamme verkkokauppoja räätälöidyillä tekoälyratkaisuilla
                jotka edistävät kasvua, tehokkuutta ja poikkeuksellisia asiakaskokemuksia.
              </p>
              <div className="flex space-x-6">
                <SocialIcon icon="twitter" />
                <SocialIcon icon="linkedin" />
                <SocialIcon icon="facebook" />
                <SocialIcon icon="instagram" />
              </div>
            </div>
            
            <div className="md:col-span-7">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
                <div>
                  <h3 className="font-interview text-xl uppercase mb-6 tracking-tight">Yritys</h3>
                  <ul className="space-y-4">
                    <FooterLink href="#">Meistä</FooterLink>
                    <FooterLink href="#">Työpaikat</FooterLink>
                    <FooterLink href="#">Blogi</FooterLink>
                    <FooterLink href="#">Lehdistö</FooterLink>
                  </ul>
                </div>
                
                <div>
                  <h3 className="font-interview text-xl uppercase mb-6 tracking-tight">Tuote</h3>
                  <ul className="space-y-4">
                    <FooterLink href="#features">Ominaisuudet</FooterLink>
                    <FooterLink href="#benefits">Edut</FooterLink>
                    <FooterLink href="#pricing">Hinnoittelu</FooterLink>
                    <FooterLink href="#faq">UKK</FooterLink>
                  </ul>
                </div>
                
                <div>
                  <h3 className="font-interview text-xl uppercase mb-6 tracking-tight">Resurssit</h3>
                  <ul className="space-y-4">
                    <FooterLink href="#">Dokumentaatio</FooterLink>
                    <FooterLink href="#">Oppaat</FooterLink>
                    <FooterLink href="#">API</FooterLink>
                    <FooterLink href="#">Status</FooterLink>
                  </ul>
                </div>
                
                <div>
                  <h3 className="font-interview text-xl uppercase mb-6 tracking-tight">Juridinen</h3>
                  <ul className="space-y-4">
                    <FooterLink href="#">Tietosuoja</FooterLink>
                    <FooterLink href="#">Käyttöehdot</FooterLink>
                    <FooterLink href="#">Tietoturva</FooterLink>
                    <FooterLink href="#">Vaatimustenmukaisuus</FooterLink>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t-2 border-black py-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-black mb-4 md:mb-0 font-interview-sans uppercase">
            &copy; {new Date().getFullYear()} OrderSales.AI. Kaikki oikeudet pidätetään.
          </p>
          <div className="flex space-x-8">
            <a href="#" className="text-sm text-black hover:text-interview-accent transition-colors font-interview-sans uppercase font-bold">
              Tietosuojakäytäntö
            </a>
            <a href="#" className="text-sm text-black hover:text-interview-accent transition-colors font-interview-sans uppercase font-bold">
              Käyttöehdot
            </a>
            <a href="#" className="text-sm text-black hover:text-interview-accent transition-colors font-interview-sans uppercase font-bold">
              Evästeet
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

interface FooterLinkProps {
  href: string;
  children: React.ReactNode;
}

const FooterLink = ({ href, children }: FooterLinkProps) => {
  return (
    <li>
      <a 
        href={href} 
        className="text-black hover:text-interview-accent transition-colors font-interview-sans"
      >
        {children}
      </a>
    </li>
  );
};

const SocialIcon = ({ icon }: { icon: string }) => {
  return (
    <a 
      href="#" 
      className="w-10 h-10 border-2 border-black flex items-center justify-center hover:bg-black hover:text-white transition-colors"
      aria-label={`Seuraa meitä: ${icon}`}
    >
      <span className="uppercase text-xs font-interview-sans font-bold">{icon.charAt(0)}</span>
    </a>
  );
};

export default Footer;
